import { defineStore } from 'pinia'
import { ref, onMounted, onUnmounted } from 'vue'

export type DistanceUnit = 'miles' | 'km'

export const useSessionStore = defineStore('session', () => {
    const screenWidth = ref(window.innerWidth)
    const screenHeight = ref(window.innerHeight)
    const mode = ref<string>(window.localStorage.getItem('mode') ?? 'dark')
    const distanceUnit = ref<DistanceUnit>((window.localStorage.getItem('distanceUnit') as DistanceUnit) ?? 'miles')

    // Work order preferences (detailedLineItemsDefault still live — powers per-line-item scheduling)
    const detailedLineItemsDefault = ref<boolean>(
        window.localStorage.getItem('detailedLineItemsDefault') === 'true'
    )

    function toggleMode(enabled: boolean) {
        const newVal = enabled ? 'dark' : ''
        mode.value = newVal
        window.localStorage.setItem('mode', mode.value)
    }

    function setDistanceUnit(unit: DistanceUnit) {
        distanceUnit.value = unit
        window.localStorage.setItem('distanceUnit', unit)
    }

    function setDetailedLineItemsDefault(enabled: boolean) {
        detailedLineItemsDefault.value = enabled
        window.localStorage.setItem('detailedLineItemsDefault', enabled.toString())
    }
    const updateScreenSize = () => {
        screenWidth.value = window.innerWidth
        screenHeight.value = window.innerHeight
    }

    onMounted(() => {
        // Update screen size on mount and listen for resize events
        window.addEventListener('resize', updateScreenSize)
    })

    onUnmounted(() => {
        // Clean up listener on component unmount
        window.removeEventListener('resize', updateScreenSize)
    })
    return {
        state: { screenWidth, screenHeight },
        mode,
        toggleMode,
        distanceUnit,
        setDistanceUnit,
        detailedLineItemsDefault,
        setDetailedLineItemsDefault
    }
})
